module.exports = __webpack_public_path__ + "img/byd.fc199b5e.png";